import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoadingDataService } from '../repositories/loading-data.service';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseDataService implements OnDestroy {

  private subscriptions: Subscription = new Subscription();

  constructor(public httpClient: HttpClient,
    public loadingService: LoadingDataService) {
  }

  public static getApiUrl() {
    return environment.ApiBaseUrl + environment.ApiPrefix;
  }

  public get<T>(uri: string, delegate: (result: T) => void, onError?: (error: any) => void): void {
    const url = this.getUrl(uri);
    const result = this.httpClient.get<T>(url).subscribe((response) => {
      delegate(response);
    }, (error) => {
      this.loadingService.loadingOtherData(false);
      this.loadingService.loadingUserData(false);
      // this.toastr.errorToastr(error, 'Api Error');
      if (onError != null) {
        onError(error);
      }
    });
    this.subscriptions.add(result);
  }

  public post<T>(uri: string, body: any, delegate: (result: T) => void, errorDelegate?: (error: any) => void): void {
    const url = this.getUrl(uri);
    const result = this.httpClient.post<T>(url, body).subscribe(delegate, (error) => {
      this.loadingService.loadingOtherData(false);
      this.loadingService.loadingUserData(false);

      if (errorDelegate) {
        errorDelegate(error);
      }

      // this.toastr.errorToastr(error, 'Api Error');
    });
    this.subscriptions.add(result);
  }

  public postWithProgress<T>(uri: string, body: any,
    delegate: (result: T) => void,
    errorDelegate?: (error: any) => void,
    progressDelegate?: (progress: number) => void): void {
    const url = this.getUrl(uri);
    const result = this.httpClient.post(url, body, { reportProgress: true, observe: 'events' }).pipe(map((event: HttpEvent<T>) => {

      switch (event.type) {
        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          progressDelegate(progress);
          break;
        case HttpEventType.Response:
          progressDelegate(-1);
          delegate(event.body);
          return event.body;
      }

      return null;
    })
    ).subscribe(() => {
    }, (error) => {
      this.loadingService.loadingOtherData(false);
      this.loadingService.loadingUserData(false);

      if (errorDelegate) {
        errorDelegate(error);
      }

      // this.toastr.errorToastr(error, 'Api Error');
    });
    this.subscriptions.add(result);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public getUrl(url: string) {
    return environment.ApiBaseUrl + environment.ApiPrefix + url;
  }
}
